<template>
  <div class="card-quote">
    <div
      class="card-quote__image"
      :style="{ backgroundImage: 'url(' + image + ')' }"
    ></div>
    <div class="card-quote__text">
      <h3 class="card-quote__quote">{{ quote.quote }}</h3>
      <p class="card-quote__person">
        <b v-if="quote.person.name">{{ quote.person.name }},</b>
        <span v-if="quote.person.position">{{ quote.person.position }} @</span>
        {{ quote.person.company }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardQuote',
  components: {},
  props: {
    quote: {
      type: Object,
      required: true
    }
  },
  computed: {
    image() {
      return require(`@/assets/components/card-quote/${this.quote.person.image}`)
    }
  }
}
</script>

<style lang="scss">
.card-quote {
  &__image {
    position: relative;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    height: rem(80px);
    width: rem(80px);
    margin-bottom: rem(-40px);
    margin-left: rem(40px);
    z-index: 2;

    @include media-breakpoint-down(md) {
      margin-left: rem(20px);
    }
  }

  &__text {
    background-color: $white;
    z-index: 1;
    padding: rem(70px) rem(60px) rem(50px) rem(40px);

    @include media-breakpoint-down(md) {
      padding: rem(70px) rem(20px) rem(40px) rem(20px);
    }
  }

  &__quote {
    font-weight: 500;
    line-height: 1.25;
    margin-bottom: rem(30px);
  }

  &__person {
    line-height: 1.5;
    color: $gray-700;

    b {
      display: block;
      color: $gray-900;
    }
  }
}
</style>
